import { createSlice } from '@reduxjs/toolkit'

const INITIAL_STATE = {
    initiatingRenewFlow: false,
    initiatingRenewFlowError: "",

    renewLicenseInProgress: false,
    renewLicenseError: "",

    documentUploadStarted: false,
    documentUploadWorking: false,
    documentUploadCompleted: false,
    documentUploadErrors: [],

    applicationData: {},
    applicationNumber: "",
    lateRenewalData: {}, // if populated should have properties of hasExpired, expirationDate and renewBy (used on confirmation page f there are late fees)
    selectedBulkRenewalLicenses: []
}

export const renewSlice = createSlice({
    name: 'renew',
    initialState: INITIAL_STATE,
    // Reducers describe operations on state. Under the hood, reducers take the
    // current state and modify it in some manner then return the modified state.
    // Redux stores the modified state as the current state.  Subsequent reducers
    // will then operate on the modified state - thus, state changes accumulate/persist
    reducers: {
        setInitiatingRenewFlowInProgress: (state) => {
            state.initiatingRenewFlow = true;
            state.initiatingRenewFlowError = "";

            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = false;
        },
        setInitiatingRenewFlowComplete: (state, action) => {
            state.initiatingRenewFlow = false
            state.initiatingRenewFlowError = action.payload
        },
        setRenewLicenseInProgress: (state) => {
            state.renewLicenseInProgress = true
            state.documentUploadErrors = []
            state.renewLicenseError = ""
        },
        setRenewLicenseCompleted: (state) => {
            state.renewLicenseInProgress = false
        },
        setRenewLicenseError: (state, action) => {
            state.renewLicenseError = action.payload
        },
        setBulkRenewalLicenses: (state, action) => {
            state.selectedBulkRenewalLicenses = action.payload;
        },
        clearBulkRenewalLicenses: (state) => {
            state.selectedBulkRenewalLicenses = []
        },
        updatePermitData: (state, action) => {
            state.applicationData = {
                ...state.applicationData,
                ...action.payload,
            }
        },
        removeRegistrantData: (state) => {
            delete state.applicationData.registrant;
        },
        removeContactsData: (state) => {
            delete state.applicationData.contacts;
        },
        removePropertyDetailsData: (state) => {
            delete state.applicationData.propertyDetails;
        },
        removeListingsData: (state) => {
            delete state.applicationData.listings;
        },
        setRenewApplicationNumber: (state, action) => {
            state.applicationNumber = action.payload
        },
        setLateRenewalData: (state, action) => {
            state.lateRenewalData = action.payload
        },
        setDocumentUploadStarted: (state, action) => {
            state.documentUploadErrors = []
            state.documentUploadWorking = false
            state.documentUploadCompleted = false
            state.documentUploadStarted = action.payload
        },
        setDocumentUploadWorking: (state, action) => {
            state.documentUploadStarted = false
            state.documentUploadCompleted = false
            state.documentUploadWorking = action.payload
        },
        setDocumentUploadCompleted: (state, action) => {
            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = action.payload
        },
        setDocumentUploadError: (state, action) => {
            state.documentUploadErrors = [
                ...state.documentUploadErrors,
                action.payload,
            ]
        },
        clearDocumentUploadError: (state) => {
            state.documentUploadErrors = []
        },
        resetDocumentUploadProgressStatus: (state) => {
            state.documentUploadStarted = false
            state.documentUploadWorking = false
            state.documentUploadCompleted = false
        },
        resetRenewState: (state) => INITIAL_STATE,
    },
})

export const {
    setInitiatingRenewFlowInProgress,
    setInitiatingRenewFlowComplete,
    updatePermitData,
    removeRegistrantData,
    removeContactsData,
    removeListingsData,
    removePropertyDetailsData,
    setRenewApplicationNumber,
    setDocumentUploadStarted,
    setDocumentUploadWorking,
    setDocumentUploadCompleted,
    setDocumentUploadError,
    resetDocumentUploadProgressStatus,
    resetRenewState,
    setRenewLicenseInProgress,
    setRenewLicenseCompleted,
    setRenewLicenseError,
    setLateRenewalData,
    setBulkRenewalLicenses,
    clearBulkRenewalLicenses
} = renewSlice.actions

export default renewSlice.reducer
